export var OptionsParam;
(function (OptionsParam) {
    OptionsParam["PHUB_TRAVEL_PERIOD_DURATION_APPLIANCE"] = "PHUB_TRAVEL_PERIOD_DURATION_APPLIANCE";
    OptionsParam["PHUB_FLIGHT_IGNORE_OPEN_JAW"] = "PHUB_FLIGHT_IGNORE_OPEN_JAW";
    OptionsParam["PHUB_HOTEL_SHOW_QUALIFIERS"] = "PHUB_HOTEL_SHOW_QUALIFIERS";
    OptionsParam["PHUB_RESULTS_TOTAL"] = "PHUB_RESULTS_TOTAL";
    OptionsParam["PHUB_FACETS"] = "PHUB_FACETS";
    OptionsParam["RELAXED_FLIGHT_OFFER_KEY"] = "RELAXED_FLIGHT_OFFER_KEY";
    OptionsParam["MERGE_SIMILAR_FLIGHTS"] = "MERGE_SIMILAR_FLIGHTS";
})(OptionsParam || (OptionsParam = {}));
